// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PshAP","field":"styles_field__2Hbsk","fieldCol":"styles_fieldCol__pKlsa","diffCol":"styles_diffCol__3KacJ","diff":"styles_diff__2WZJY"};